import ErrorOccured           from "./game/changes/ErrorOccured"
import Game                   from "./game/Game"
import GameState              from "./game/GameState"
import Log                    from "./game/Log"
import MapLoader              from "./game/MapLoader"
import Runtime                from "./game/Runtime"
import Screen                 from "./game/Screen"
import FetchResponseNotOk     from "./game/errors/FetchResponseNotOk"
import InvalidCoordinates     from "./game/errors/InvalidCoordinates"
import CoordinatesOutOfBounds from "./game/errors/CoordinatesOutOfBounds"
import ImagePreloader         from "./game/ImagePreloader"

class Boot {
  constructor(window) {
    this.window    = window
    this.log       = new Log({ forClassName: "Boot", window: window })
    this.gameState = new GameState({ window: window, log: this.log })
    this.game      = undefined

    this.mapLoader = new MapLoader({
      worldId: "starlight",
      forceNoCache: Runtime.env().isDev(),
      log: this.log,
      window: this.window,
      forceSlowNetwork: Runtime.instance().forceSlowNetwork,
    })

    this.screen = new Screen({
      window: this.window,
      log: this.log,
    })

    const performanceObserver = Runtime.instance().performanceObserver()
    //performanceObserver.start()

    const imagePreloader = new ImagePreloader({ window: window, log: this.log, worldId: "starlight" })
    imagePreloader.preloadImages().then( () => {
      console.log("Images pre-loaded")
    }).catch( (error) => {
      console.warn("While pre-loading images: %o",error)
    })
  }

  start() {
    const logger = this.log.method("start", { mapName: this.gameState.mapName() })
    this._removeQueryString()
    const mapName = this.gameState.mapName() || "planet"
    logger.addDetails({ actualMapName: mapName })
    return this.mapLoader.loadMap({
      mapName: mapName,
      travelerName: this.gameState.traveler(),
    }).then( (gameMap) => {
      logger.end()
      return this._startGame(gameMap)
    }).catch( (error) => {
      logger.end({ error: true })
      this._handleError(error)
    })
  }

  _removeQueryString() {
    // We use the query string to communicate across reloads, but we don't want this stuff
    // hanging around, so clear it out.
    setTimeout( () => {
      this.window.history.replaceState({}, "unused", this.window.location.href.split("?")[0])
    }, 3000)
  }

  _handleError(error) {
    if (error instanceof FetchResponseNotOk) {
      if ( (error.response.status == 404) && this.gameState.mapName() ) {
        console.error("State may have been corrupted. Resetting.")
        this.gameState.clear()
        this._reloadOrThrow(error)
      }
      else {
        throw error
      }
    }
    if (error instanceof InvalidCoordinates) {
      if ( (error.travelerX == this.gameState.travelerX()) && 
        (error.travelerY == this.gameState.travelerY()) ) {
        console.error("State may have been corrupted. Resetting.")
        this.gameState.clear()
        this._reloadOrThrow(error)
      }
      else {
        throw error
      }
    }
    else if (error instanceof CoordinatesOutOfBounds) {
      if ( (this.gameState.travelerX() > error.map.width) ||
        (this.gameState.travelerY() > error.map.height) ) {
        console.error("State may have been corrupted. Resetting.")
        this.gameState.clear()
        this._reloadOrThrow(error)
      }
      else {
        throw error
      }
    }
    else {
      throw error
    }
  }

  _forcedReload() {
    const params = new URLSearchParams(this.window.location.search)
    return params.get("forcereload") === "true"
  }

  _reloadOrThrow(error) {
    if (this._forcedReload()) {
      console.error("Page has already had a reload to attempt to correct an error. Not trying again")
      throw error
    }
    else {
      this.window.location.href = this.window.location.pathname + "?forcereload=true"
    }
  }

  error(promiseRejectionEvent) {
    if (this.game) {
      this.game.fireStateChange(new ErrorOccured(promiseRejectionEvent.reason))
    }
    else {
      throw promiseRejectionEvent
    }
  }


  _startGame(gameMap) {
    const logger = this.log.method("_afterMapLoad")

    const [ travelerX, travelerY ] = this.gameState.travelerCoordinates(gameMap)

    this.game = new Game({
      window: this.window,
      gameMap: gameMap,
      travelerStartX: travelerX,
      travelerStartY: travelerY,
      log: this.log,
      newGame: this.gameState.isNew(),
      mapLoader: this.mapLoader,
    })

    this.game.addStateChangeListener(this.screen.render.bind(this.screen))
    this.game.addStateChangeListener(this.gameState.saveState.bind(this.gameState))
    this.game.start(this._forcedReload())
    logger.end()
  }
}

export default Boot
